import { Button } from '@/components/Button';
import { Text } from '@/components/Text';
import { useTranslation } from 'react-i18next';
import { FaExchangeAlt, FaUserPlus } from 'react-icons/fa';

interface CardProfileProps {
  fullName: string | null;
  job: string | null;
  company: string | null;
  onAddContact: () => void;
  onExchange?: () => void;
}

export const CardProfile = ({
  fullName,
  job,
  company,
  onAddContact,
  onExchange,
}: CardProfileProps) => {
  const { t } = useTranslation();

  return (
    <div className="px-6 pt-24">
      <div className="text-center">
        <Text className="text-2xl font-semibold text-linko-dark">
          {fullName}
        </Text>
        {job && (
          <Text className="mt-1 text-sm font-medium text-gray-dark">{job}</Text>
        )}
        {company && (
          <Text className="mt-0.5 text-sm text-gray-dark">{company}</Text>
        )}
      </div>

      {/* Buttons Container */}
      <div className="mt-6 flex justify-center gap-4">
        {/* Add contact button */}
        <Button onClick={onAddContact} className="w-[125px] rounded-full">
          <FaUserPlus className="-ml-0.5 size-4" />
          {t('digitalCard:addContact')}
        </Button>

        {/* Exchange button */}
        {onExchange && (
          <Button
            onClick={onExchange}
            className="w-[125px] rounded-full bg-linko-light"
          >
            <FaExchangeAlt className="-ml-0.5 size-4" />
            {t('digitalCard:exchange.button')}
          </Button>
        )}
      </div>
    </div>
  );
};
